{
  "itemSelection": {
    "title": "Which item needs warranty service?",
    "noEligibleItems": "No items in this order are eligible for warranty service.",
    "price": "Price: {price}"
  },
  "uploadProof": {
    "title": "Describe the issue",
    "prompt": "Tell us what's wrong with this item.",
    "removeFile": "Remove file",
    "uploadPhotos": "Upload photos",
    "uploadPhotosRequired": "Upload photos (required)",
    "maxFileSize": "Maximum upload file size: 15 MB",
    "commentRequired": "Add comment (required)",
    "commentOptional": "Add comment (optional)",
    "uploadFailed": "Upload failed"
  },
  "summary": {
    "title": "Here's a summary of your warranty claim. Does everything look correct?",
    "warrantyItem": "Warranty Item",
    "details": "Details",
    "resolution": "Resolution",
    "replacement": "Replacement",
    "description": "Description",
    "attachedFiles": "Attached files",
    "submitFailed": "Failed to submit warranty claim"
  },
  "confirmation": {
    "title": "Your warranty claim has been filed.",
    "claimNumber": "Warranty claim #{number}",
    "whatsNext": "What's next",
    "received": "We've received your warranty claim. We'll review it and follow up by email once it's been processed.",
    "receivedWithName": "We've received your warranty claim, {name}. We'll review it and follow up by email once it's been processed."
  }
}
